import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasImagenRepresentacionEmpresaAtom, puntajeTotalImagenRepresentacionEmpresaAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasImagenRepresentacionEmpresa = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalImagenRepresentacionEmpresaAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasImagenRepresentacionEmpresaAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasImagenRepresentacionEmpresa;
